import { SettelementLetterDto } from './../../../../../../core/models/SettelementLetterDocument';
import { PaymentDetailsDto } from './../../../../../../core/models/paymentDetails';
import { DocumentDetails } from './../../../../../../core/models/DocumentDetails';
import swal from 'sweetalert2';
import { ClaimsQueryDto } from './../../../../../../core/models/ClaimsQueryDto';
import { ClaimsService } from 'src/app/core/services/claims.service';
import { ClaimDocumentsListComponent } from './../../../../../home/components/claim-initiation/claim-documents-list/claim-documents-list.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { RejectReasonsDto } from 'src/app/core/models/RejectReasonsDto';
import { EmailDto } from 'src/app/core/models/EmailDto';
import { HttpUrlEncodingCodec } from '@angular/common/http';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DocumentViewerComponent } from './../../../../../../shared/components/document-viewer/document-viewer.component';

@Component({
  selector: 'app-tpa-email',
  templateUrl: './tpa-email.component.html',
  styleUrls: ['./tpa-email.component.scss'],
  providers: [HttpUrlEncodingCodec]
})
export class TpaEmailComponent implements OnInit {
  thispreviewimageUrl: any;
  locDocFile: any;
  queryAnswer: any;
  queryNotes: any;
  rejectReason: any;
  timeStamp: any;
  allDocuments: any;
  totalDocument = 0;
  PaymentDetailsList: any;
  queryLetter: any;
  locFile!: DocumentDetails;
  listOfPaymentDetails: any;
  singlePayment: any = [];
  documents: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private claimsService: ClaimsService,
    private httpUrlEncodingCodec: HttpUrlEncodingCodec, private dialog: MatDialog, public dialogRef: MatDialogRef<TpaEmailComponent>, private formBuilder: FormBuilder,) { }
  queryResponse = false;
  hospitalEmailData: EmailDto = new EmailDto({});
  claimQuery: ClaimsQueryDto = new ClaimsQueryDto({});
  rejectReasons: RejectReasonsDto = new RejectReasonsDto({});
  PaymentDetails: PaymentDetailsDto = new PaymentDetailsDto({});
  SettleDocs: SettelementLetterDto = new SettelementLetterDto({});
  dischargeFinalDate = new Date();
  zeroAmount = 0;
  admissionDateChanged: Boolean = false;
  dischargeDateChanged: Boolean = false;
  maxDate = new Date();
  dischargeDate = new Date();
  public settlementForm!: FormGroup; 
  
  public settleMentFormGroup(): FormGroup {
    return new FormGroup({
      paidAmount: new FormControl('', Validators.required),
      tdsAmount: new FormControl('', Validators.required),
      utrNo: new FormControl('', [Validators.required,  Validators.pattern('^([A-Za-z0-9]{0,})$')]),
      paymentDate: new FormControl('', Validators.required),
      commentBox: new FormControl('', Validators.required),
    })
  }
  ngOnInit(): void {
    this.settlementForm = this.formBuilder.group({
      settlementType: ['', Validators.required],
      approvedAmount: ['', Validators.required],
      settlementGroups: this.formBuilder.array([this.settleMentFormGroup()]),
    });
    if (this.data) {
      if (this.data.statusType === 'PRE_AUTH_UNDER_QUERY' || this.data.statusType === 'ENHANCEMENT_UNDER_QUERY' || this.data.statusType === 'FINAL_BILLS_UNDER_QUERY' || this.data.statusType === 'FILE_SUBMITTED_UNDER_QUERY') {
        if (this.data?.mailDocument) {
          this.data.queryDocuments = [];
          this.data.queryDocuments.push(this.data.mailDocument);
          this.thispreviewimageUrl = this.data.mailDocument.$file;
        }
        this.claimQuery.$timestamp = new Date(this.data?.mailTime);
      }

      if (this.data.statusType === 'PRE_APPROVAL_RECEIVED' || this.data.statusType === 'REJECT' || this.data.statusType === 'ENHANCEMENT_APPROVAL_RECEIVED' || this.data.statusType === 'APPROVE') {
        if (this.data?.mailDocument) {
          this.thispreviewimageUrl = this.data.mailDocument.$file;
          this.locFile = this.data.mailDocument;
        }
      }

      if (this.data.statusType === 'SETTLED') {
        if (this.data?.mailDocument) {
          this.locFile = this.data.mailDocument;
          if (this.documents) {
            this.documents.push(this.data.mailDocument);
          } else {
            this.documents = [];
            this.documents.push(this.data.mailDocument);
          }
        }
      }
      this.totalDocument = 0;
      this.data.claimDetails.claimDocuments.forEach((element: any) => {
        if (element.documents) {
          this.totalDocument = this.totalDocument + element.documents.length;
        }
      });
      if (this.data.claimDetails.claimQueries?.length > 0) {
        this.data.claimDetails.claimQueries.forEach((element: any) => {
          if (element.isActive) {
            if (element.timestamp) {
              element.timestamp = new Date(element.timestamp);
            }
            this.claimQuery = element;
            this.timeStamp = element.timestamp;
            this.downloadQueryDocument(element.queryDocuments[0].url);
          }
        });
        this.allDocuments = this.data.claimDetails?.paymentDetails?.settelementLetterDocument;
      }
      if (this.data.statusType === 'PRE_APPROVAL_RECEIVED' || this.data.statusType === 'ENHANCEMENT_APPROVAL_RECEIVED' || this.data.statusType === 'DISCHARGE' || this.data.statusType === 'APPROVE') {
        if (this.data.statusType === 'PRE_APPROVAL_RECEIVED') {
          this.data.claimDetails.invoiceDetails.totalInvoiceAmount = this.data.claimDetails.invoiceDetails.totalApprovedAmount;
        }
        if (!this.data.claimDetails.invoiceDetails.totalNonClaimableAmount) {
          this.data.claimDetails.invoiceDetails.totalNonClaimableAmount = 0;
        }
      }
      if (this.data.statusType === 'SETTLED') {
        this.dischargeDate = this.data.claimDetails?.claimDetails?.policyStatus?.policyValidity?.dischargeDate;
        this.settlementForm.controls['approvedAmount'].setValue(this.data.claimDetails?.claimAmount?.tariffsAndDiscounts?.totalClaimedAmount - this.data.claimDetails?.claimAmount?.tariffsAndDiscounts?.totalDeductions);
      }
    }
    this.getSum();
  }

  convertToUTCDate(date: Date) {
    const interimDateTimeStamp = new Date(date).getTime();
    date = new Date(interimDateTimeStamp);
    date.setUTCHours(24, 0, 0, 0);
    return date;
  }

  admissionChange(event: any) {
    if (event) {
      this.admissionDateChanged = true;
    } else {
      this.admissionDateChanged = false;
    }
  }

  dischargeChange(event: any) {
    if (event) {
      this.dischargeDateChanged = true;
    } else {
      this.dischargeDateChanged = false;
    }
  }

  submitClick() {
    swal.fire({ title: 'Processing...' });
    swal.showLoading();
    if (this.data.claimDetails.claimDocuments) {
      let ele = this.data.claimDetails.claimDocuments.find(
        (element: any) => element.mandatory && !(element.documents));
      if (ele) {
        swal.close();
        swal.fire(
          'Please Upload All Mandatory Documents',
          '',
          'warning'
        );
        return;
      }
    } else {
      swal.close();
      swal.fire(
        'Please Upload All Mandatory Documents',
        '',
        'warning'
      );
      return;
    }
    switch (this.data.statusType) {
      case "PRE_AUTH_UNDER_QUERY":
        if (this.queryResponse === true) {
          this.claimQuery.$isActive = true;
          this.claimQuery.$isAnswered = false;
          this.claimQuery.$claimStatus = "PRE_AUTH_UNDER_QUERY";
          this.claimQuery.$claimId = this.data.claimDetails.claimId;
          // this.claimQuery.$remarks = this.queryNotes;
          this.claimQuery.$queryDocuments = this.data.queryDocuments;
          this.claimsService.unRaisedQuery(this.claimQuery).subscribe(
            (data: any) => {
              this.hospitalEmailData = new EmailDto({});
              this.hospitalEmailData.$claimStatus = "PRE_AUTH_QUERY_RESPONDED";
              this.hospitalEmailData.$claimId = this.data.claimDetails.claimId;
              this.hospitalEmailData.$claimsQueryDto.$isActive = false;
              this.hospitalEmailData.$claimsQueryDto.$isAnswered = true;
              this.hospitalEmailData.$claimsQueryDto.$remarks = this.queryNotes;
              this.hospitalEmailData.$claimDocuments = this.data.claimDetails.claimDocuments;
              this.claimsService.unRespondedQuery(this.hospitalEmailData).subscribe(
                data => {
                  swal.close();
                  swal.fire('Query Submitted successfully.', '', 'success');
                  this.dialogRef.close('success');
                }, error => {
                  swal.close();
                  swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
                }
              );
            }, error => {
              swal.close();
              swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
            }
          );
        } else if (this.queryResponse === false) {
          // this.data.claimDetails.claimStatus = "PRE_AUTH_UNDER_QUERY";
          // this.data.claimDetails.claimAction.newStatus = "PRE_AUTH_UNDER_QUERY";
          if (!this.claimQuery.$timestamp) {
            swal.close();
            swal.fire(
              'Please Select Query Time',
              '',
              'warning'
            );
            return;
          }
          if (!this.thispreviewimageUrl) {
            swal.close();
            swal.fire(
              'Please Upload Query Letter',
              '',
              'warning'
            );
            return;
          }
          this.claimQuery.$isActive = true;
          this.claimQuery.$isAnswered = false;
          this.claimQuery.$claimStatus = "PRE_AUTH_UNDER_QUERY";
          this.claimQuery.$claimId = this.data.claimDetails.claimId;
          this.claimQuery.$queryDocuments = this.data.queryDocuments;

          // if(this.data.claimDetails?.claimQueries.length > 0) {
          //   this.data.claimDetails.claimQueries.splice(0, 0, this.claimQuery);
          // } else {
          //   this.data.claimDetails.claimQueries.push(this.claimQuery);
          // }

          this.claimsService.unRaisedQuery(this.claimQuery).subscribe(
            data => {
              swal.close();
              swal.fire('Query Submitted successfully.', '', 'success');
              this.dialogRef.close('success');
            }, error => {
              swal.close();
              swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
            }
          );
        }
        break;
      case "ENHANCEMENT_UNDER_QUERY":
        if (this.queryResponse === true) {
          this.claimQuery.$isActive = true;
          this.claimQuery.$isAnswered = false;
          this.claimQuery.$claimStatus = "ENHANCEMENT_UNDER_QUERY";
          this.claimQuery.$remarks = this.queryNotes;
          this.claimQuery.$claimId = this.data.claimDetails.claimId;
          this.claimsService.unRaisedQuery(this.claimQuery).subscribe(
            (data: any) => {
              this.hospitalEmailData = new EmailDto({});
              this.hospitalEmailData.$claimStatus = "ENHANCEMENT_QUERY_RESPONDED";
              this.hospitalEmailData.$claimId = this.data.claimDetails.claimId;
              this.hospitalEmailData.$claimsQueryDto.$isActive = false;
              this.hospitalEmailData.$claimsQueryDto.$isAnswered = true;
              this.hospitalEmailData.$claimsQueryDto.$remarks = this.queryNotes;
              this.hospitalEmailData.$claimDocuments = this.data.claimDetails.claimDocuments;
              this.claimsService.unRespondedQuery(this.hospitalEmailData).subscribe(
                data => {
                  swal.close();
                  swal.fire('Query Submitted successfully.', '', 'success');
                  this.dialogRef.close('success');
                }, error => {
                  swal.close();
                  swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
                }
              );
            }, error => {
              swal.close();
              swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
            }
          );
        } else if (this.queryResponse === false) {
          if (!this.claimQuery.$timestamp) {
            swal.close();
            swal.fire(
              'Please Select Query Time',
              '',
              'warning'
            );
            return;
          }
          if (!this.thispreviewimageUrl) {
            swal.close();
            swal.fire(
              'Please Upload Query Letter',
              '',
              'warning'
            );
            return;
          }
          this.claimQuery.$isActive = true;
          this.claimQuery.$isAnswered = false;
          this.claimQuery.$claimStatus = "ENHANCEMENT_UNDER_QUERY";
          this.claimQuery.$claimId = this.data.claimDetails.claimId;
          this.claimQuery.$queryDocuments = this.data.queryDocuments;
          this.claimsService.unRaisedQuery(this.claimQuery).subscribe(
            data => {
              swal.close();
              swal.fire('Query Submitted successfully.', '', 'success');
              this.dialogRef.close('success');
            }, error => {
              swal.close();
              swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
            }
          );
        }
        break;
      case "FINAL_BILLS_UNDER_QUERY":
        if (this.queryResponse === true) {
          this.claimQuery.$isActive = true;
          this.claimQuery.$isAnswered = false;
          this.claimQuery.$claimStatus = "FINAL_BILLS_UNDER_QUERY";
          this.claimQuery.$claimId = this.data.claimDetails.claimId;
          this.claimsService.unRaisedQuery(this.claimQuery).subscribe(
            (data: any) => {
              this.hospitalEmailData = new EmailDto({});
              this.hospitalEmailData.$claimStatus = "FINAL_BILLS_QUERY_RESPONDED";
              this.hospitalEmailData.$claimId = this.data.claimDetails.claimId;
              this.hospitalEmailData.$claimsQueryDto.$isActive = false;
              this.hospitalEmailData.$claimsQueryDto.$isAnswered = true;
              this.hospitalEmailData.$claimsQueryDto.$remarks = this.queryNotes;
              this.hospitalEmailData.$claimDocuments = this.data.claimDetails.claimDocuments;
              this.claimsService.unRespondedQuery(this.hospitalEmailData).subscribe(
                data => {
                  swal.close();
                  swal.fire('Query Submitted successfully.', '', 'success');
                  this.dialogRef.close('success');
                }, error => {
                  swal.close();
                  swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
                }
              );
            }, error => {
              swal.close();
              swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
            }
          );
        } else if (this.queryResponse === false) {
          if (!this.claimQuery.$timestamp) {
            swal.close();
            swal.fire(
              'Please Select Query Time',
              '',
              'warning'
            );
            return;
          }
          if (!this.thispreviewimageUrl) {
            swal.close();
            swal.fire(
              'Please Upload Query Letter',
              '',
              'warning'
            );
            return;
          }
          this.claimQuery.$isActive = true;
          this.claimQuery.$isAnswered = false;
          this.claimQuery.$claimStatus = "FINAL_BILLS_UNDER_QUERY";
          this.claimQuery.$claimId = this.data.claimDetails.claimId;
          this.claimQuery.$queryDocuments = this.data.queryDocuments;
          this.claimsService.unRaisedQuery(this.claimQuery).subscribe(
            data => {
              swal.close();
              swal.fire('Query Submitted successfully.', '', 'success');
              this.dialogRef.close('success');
            }, error => {
              swal.close();
              swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
            }
          );
        }
        break;
      case "FILE_SUBMITTED_UNDER_QUERY":
        if (this.queryResponse === true) {
          this.claimQuery.$isActive = true;
          this.claimQuery.$isAnswered = false;
          this.claimQuery.$claimStatus = "FILE_SUBMITTED_UNDER_QUERY";
          this.claimQuery.$claimId = this.data.claimDetails.claimId;
          this.claimsService.unRaisedQuery(this.claimQuery).subscribe(
            (data: any) => {
              this.hospitalEmailData = new EmailDto({});
              this.hospitalEmailData.$claimStatus = "FILE_SUBMITTED_QUERY_RESPONDED";
              this.hospitalEmailData.$claimId = this.data.claimDetails.claimId;
              this.hospitalEmailData.$claimsQueryDto.$isActive = false;
              this.hospitalEmailData.$claimsQueryDto.$isAnswered = true;
              this.hospitalEmailData.$claimsQueryDto.$remarks = this.queryNotes;
              this.hospitalEmailData.$claimDocuments = this.data.claimDetails.claimDocuments;
              this.claimsService.unRespondedQuery(this.hospitalEmailData).subscribe(
                data => {
                  swal.close();
                  swal.fire('Query Submitted successfully.', '', 'success');
                  this.dialogRef.close('success');
                }, error => {
                  swal.close();
                  swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
                }
              );
            }, error => {
              swal.close();
              swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
            }
          );
        } else if (this.queryResponse === false) {
          if (!this.claimQuery.$timestamp) {
            swal.close();
            swal.fire(
              'Please Select Query Time',
              '',
              'warning'
            );
            return;
          }
          if (!this.thispreviewimageUrl) {
            swal.close();
            swal.fire(
              'Please Upload Query Letter',
              '',
              'warning'
            );
            return;
          }
          this.claimQuery.$isActive = true;
          this.claimQuery.$isAnswered = false;
          this.claimQuery.$claimStatus = "FILE_SUBMITTED_UNDER_QUERY";
          this.claimQuery.$claimId = this.data.claimDetails.claimId;
          this.claimQuery.$queryDocuments = this.data.queryDocuments;
          this.claimsService.unRaisedQuery(this.claimQuery).subscribe(
            data => {
              swal.close();
              swal.fire('Query Submitted successfully.', '', 'success');
              this.dialogRef.close('success');
            }, error => {
              swal.close();
              swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
            }
          );
        }
        break;
      case "PRE_APPROVAL_RECEIVED":
        if (!this.data.claimDetails.invoiceDetails.totalApprovedAmount) {
          swal.close();
          swal.fire(
            'Please Enter Approved Amount',
            '',
            'warning'
          );
          return;
        }

        if (this.data.claimDetails.invoiceDetails.totalNonClaimableAmount == null || this.data.claimDetails.invoiceDetails.totalNonClaimableAmount == undefined) {
          swal.close();
          swal.fire(
            'Please Enter Disapproved Amount',
            '',
            'warning'
          );
          return;
        }
        if (!this.data.claimDetails.invoiceDetails.totalInvoiceAmount) {
          swal.close();
          swal.fire(
            'Please Enter Total Amount',
            '',
            'warning'
          );
          return;
        }
        if (!this.thispreviewimageUrl) {
          swal.close();
          swal.fire(
            'Please Upload LOC Document',
            '',
            'warning'
          );
          return;
        }
        if (this.data.claimDetails.locDetails) {
          this.data.claimDetails.locDetails.push(this.locFile);
          this.data.claimDetails.locDetails[this.data.claimDetails.locDetails.length - 1].authorizationAmount = this.data.claimDetails.invoiceDetails.totalApprovedAmount;
        } else {
          this.data.claimDetails.locDetails = [];
          this.data.claimDetails.locDetails.push(this.locFile);
          this.data.claimDetails.locDetails[0].authorizationAmount = this.data.claimDetails.invoiceDetails.totalApprovedAmount;
        }
        this.data.claimDetails.claimStatus = 'PRE_APPROVAL_RECEIVED';
        this.claimsService.unApproveClaim(this.data.claimDetails).subscribe(
          data => {
            swal.close();
            swal.fire('Approval Received.', '', 'success');
            this.dialogRef.close('success');
          }, error => {
            swal.close();
            swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
          }
        );
        break;
      case "ENHANCEMENT_APPROVAL_RECEIVED":
        if (!this.data.claimDetails.invoiceDetails.totalApprovedAmount) {
          swal.close();
          swal.fire(
            'Please Enter Approved Amount',
            '',
            'warning'
          );
          return;
        }

        if (this.data.claimDetails.invoiceDetails.totalNonClaimableAmount == null || this.data.claimDetails.invoiceDetails.totalNonClaimableAmount == undefined) {
          swal.close();
          swal.fire(
            'Please Enter Disapproved Amount',
            '',
            'warning'
          );
          return;
        }
        if (!this.data.claimDetails.invoiceDetails.totalInvoiceAmount) {
          swal.close();
          swal.fire(
            'Please Enter Total Amount',
            '',
            'warning'
          );
          return;
        }
        if (!this.thispreviewimageUrl) {
          swal.close();
          swal.fire(
            'Please Upload LOC Document',
            '',
            'warning'
          );
          return;
        }
        if (this.data.claimDetails.locDetails) {
          this.data.claimDetails.locDetails.push(this.locFile);
          this.data.claimDetails.locDetails[this.data.claimDetails.locDetails.length - 1].authorizationAmount = this.data.claimDetails.invoiceDetails.totalApprovedAmount;
        } else {
          this.data.claimDetails.locDetails = [];
          this.data.claimDetails.locDetails.push(this.locFile);
          this.data.claimDetails.locDetails[0].authorizationAmount = this.data.claimDetails.invoiceDetails.totalApprovedAmount;
        }
        this.data.claimDetails.claimStatus = "ENHANCEMENT_APPROVED";
        this.claimsService.unApproveClaim(this.data.claimDetails).subscribe(
          data => {
            swal.close();
            swal.fire('Approval Received.', '', 'success');
            this.dialogRef.close('success');
          }, error => {
            swal.close();
            swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
          }
        );
        break;
      case "APPROVE":
        if (!this.data.claimDetails.invoiceDetails.totalApprovedAmount) {
          swal.close();
          swal.fire(
            'Please Enter Approved Amount',
            '',
            'warning'
          );
          return;
        }

        if (this.data.claimDetails.invoiceDetails.totalNonClaimableAmount == null || this.data.claimDetails.invoiceDetails.totalNonClaimableAmount == undefined) {
          swal.close();
          swal.fire(
            'Please Enter Disapproved Amount',
            '',
            'warning'
          );
          return;
        }
        if (!this.data.claimDetails.invoiceDetails.totalInvoiceAmount) {
          swal.close();
          swal.fire(
            'Please Enter Total Amount',
            '',
            'warning'
          );
          return;
        }
        if (!this.thispreviewimageUrl) {
          swal.close();
          swal.fire(
            'Please Upload LOC Document',
            '',
            'warning'
          );
          return;
        }
        if (this.data.claimDetails.locDetails) {
          this.data.claimDetails.locDetails.push(this.locFile);
          this.data.claimDetails.locDetails[this.data.claimDetails.locDetails.length - 1].authorizationAmount = this.data.claimDetails.invoiceDetails.totalApprovedAmount;
        } else {
          this.data.claimDetails.locDetails = [];
          this.data.claimDetails.locDetails.push(this.locFile);
          this.data.claimDetails.locDetails[0].authorizationAmount = this.data.claimDetails.invoiceDetails.totalApprovedAmount;
        }
        this.data.claimDetails.claimStatus = "CLAIM_APPROVED";

        this.claimsService.unApproveClaim(this.data.claimDetails).subscribe(
          data => {
            swal.close();
            swal.fire('Calim Approved.', '', 'success');
            this.dialogRef.close('success');
          }, error => {
            swal.close();
            swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
          }
        );
        break;
      case "DISCHARGE":
        if (!this.data.claimDetails.invoiceDetails.totalInvoiceAmount) {
          swal.close();
          swal.fire(
            'Please Enter Requested Amount',
            '',
            'warning'
          );
          return;
        }
        this.data.claimDetails.claimStatus = "FINAL_BILLS_SUBMITTED";
        if (this.admissionDateChanged) {
          this.data.claimDetails.claimDetails.policyStatus.policyValidity.admissionDate = this.convertToUTCDate(this.data.claimDetails.claimDetails.policyStatus.policyValidity.admissionDate);
        }
        if (this.dischargeDateChanged) {
          this.data.claimDetails.claimDetails.policyStatus.policyValidity.dischargeDate = this.convertToUTCDate(this.data.claimDetails.claimDetails.policyStatus.policyValidity.dischargeDate);
        }
        this.claimsService.unDischarge(this.data.claimDetails).subscribe(
          data => {
            swal.close();
            swal.fire('Final Bill Submitted.', '', 'success');
            this.dialogRef.close('success');
          }, error => {
            swal.close();
            swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
          }
        );
        break;
      case "REJECT":
        if (!this.rejectReason) {
          swal.close();
          swal.fire(
            'Please Enter Reason',
            '',
            'warning'
          );
          return;
        }
        if (!this.thispreviewimageUrl) {
          swal.close();
          swal.fire(
            'Please Upload LOC Document',
            '',
            'warning'
          );
          return;
        }
        if (this.data.claimDetails.locDetails) {
          this.data.claimDetails.locDetails.push(this.locFile);
        } else {
          this.data.claimDetails.locDetails = [];
          this.data.claimDetails.locDetails.push(this.locFile);
        }
        this.data.claimDetails.claimStatus = "CLAIM_REJECTED";
        if (this.rejectReasons.$reasons) {
          this.rejectReasons.$reasons.push(this.rejectReason);
        } else {
          this.rejectReasons.$reasons = [];
          this.rejectReasons.$reasons.push(this.rejectReason);
        }

        if (this.data.claimDetails.rejectReasons) {
          this.data.claimDetails.rejectReasons.push(this.rejectReasons);
        } else {
          this.data.claimDetails.rejectReasons = [];
          this.data.claimDetails.rejectReasons.push(this.rejectReasons);
        }
        this.claimsService.unRejectClaim(this.data.claimDetails).subscribe(
          data => {
            swal.close();
            swal.fire('Claim Rejected.', '', 'success');
            this.dialogRef.close('success');
          }, error => {
            swal.close();
            swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
          }
        );
        break;
      case "ENHANCEMENT_APPROVED":
        this.claimQuery.$isActive = true;
        this.claimQuery.$isAnswered = false;
        this.claimQuery.$claimStatus = "ENHANCEMENT_APPROVED";
        this.claimQuery.$claimId = this.data.claimDetails.claimId;
        this.claimsService.unApproveClaim(this.claimQuery).subscribe(
          data => {
            swal.close();
            swal.fire('Enhancement Approved.', '', 'success');
            this.dialogRef.close('success');
          }, error => {
            swal.close();
            swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
          }
        );
        break;
      case "CLAIM_APPROVED":
        this.claimQuery.$isActive = true;
        this.claimQuery.$isAnswered = false;
        this.claimQuery.$claimStatus = "CLAIM_APPROVED";
        this.claimQuery.$claimId = this.data.claimDetails.claimId;
        this.claimsService.unRaisedQuery(this.claimQuery).subscribe(
          data => {
            swal.close();
            swal.fire('Claim Approved.', '', 'success');
            this.dialogRef.close('success');
          }, error => {
            swal.close();
            swal.fire('', error ? error : 'Something went wrong! please try again later', 'error');
          }
        );
        break;
      case "PRE_AUTH_QUERY_RESPONDED":
        if (!this.queryNotes) {
          swal.close();
          swal.fire(
            'Please Enter Query Response',
            '',
            'warning'
          );
          return;
        }
        this.hospitalEmailData = new EmailDto({});

        this.hospitalEmailData.$claimStatus = "PRE_AUTH_QUERY_RESPONDED";
        this.hospitalEmailData.$claimId = this.data.claimDetails.claimId;
        this.hospitalEmailData.$claimsQueryDto.$isActive = false;
        this.hospitalEmailData.$claimsQueryDto.$isAnswered = true;
        this.hospitalEmailData.$claimsQueryDto.$remarks = this.queryNotes;
        this.hospitalEmailData.$claimDocuments = this.data.claimDetails.claimDocuments;

        this.claimsService.unRespondedQuery(this.hospitalEmailData).subscribe(
          data => {
            swal.close();
            swal.fire('Query Responded.', '', 'success');
            this.dialogRef.close('success');
          }
        );
        break;
      case "ENHANCEMENT_QUERY_RESPONDED":
        if (!this.queryNotes) {
          swal.close();
          swal.fire(
            'Please Enter Query Response',
            '',
            'warning'
          );
          return;
        }
        this.hospitalEmailData = new EmailDto({});

        this.hospitalEmailData.$claimStatus = "ENHANCEMENT_QUERY_RESPONDED";
        this.hospitalEmailData.$claimId = this.data.claimDetails.claimId;
        this.hospitalEmailData.$claimsQueryDto.$isActive = false;
        this.hospitalEmailData.$claimsQueryDto.$isAnswered = true;
        this.hospitalEmailData.$claimsQueryDto.$remarks = this.queryNotes;
        this.hospitalEmailData.$claimDocuments = this.data.claimDetails.claimDocuments;

        this.claimsService.unRespondedQuery(this.hospitalEmailData).subscribe(
          data => {
            swal.close();
            swal.fire('Query Responded .', '', 'success');
            this.dialogRef.close('success');
          }
        );
        break;
      case "FINAL_BILLS_QUERY_RESPONDED":
        if (!this.queryNotes) {
          swal.close();
          swal.fire(
            'Please Enter Query Response',
            '',
            'warning'
          );
          return;
        }
        this.hospitalEmailData = new EmailDto({});

        this.hospitalEmailData.$claimStatus = "FINAL_BILLS_QUERY_RESPONDED";
        this.hospitalEmailData.$claimId = this.data.claimDetails.claimId;
        this.hospitalEmailData.$claimsQueryDto.$isActive = false;
        this.hospitalEmailData.$claimsQueryDto.$isAnswered = true;
        this.hospitalEmailData.$claimsQueryDto.$remarks = this.queryNotes;
        this.hospitalEmailData.$claimDocuments = this.data.claimDetails.claimDocuments;

        this.claimsService.unRespondedQuery(this.hospitalEmailData).subscribe(
          data => {
            swal.close();
            swal.fire('Query Responded.', '', 'success');
            this.dialogRef.close('success');
          }
        );
        break;
      case "FILE_SUBMITTED_QUERY_RESPONDED":
        if (!this.queryNotes) {
          swal.close();
          swal.fire(
            'Please Enter Query Response',
            '',
            'warning'
          );
          return;
        }
        this.hospitalEmailData = new EmailDto({});
        this.hospitalEmailData.$claimStatus = "FILE_SUBMITTED_QUERY_RESPONDED";
        this.hospitalEmailData.$claimId = this.data.claimDetails.claimId;
        this.hospitalEmailData.$claimsQueryDto.$isActive = false;
        this.hospitalEmailData.$claimsQueryDto.$isAnswered = true;
        this.hospitalEmailData.$claimsQueryDto.$remarks = this.queryNotes;
        this.hospitalEmailData.$claimDocuments = this.data.claimDetails.claimDocuments;
        this.claimsService.unRespondedQuery(this.hospitalEmailData).subscribe(
          data => {
            swal.close();
            swal.fire('Query Responded.', '', 'success');
            this.dialogRef.close('success');
          }
        );
        break;
      case "SETTLED":
        if (this.settlementForm.controls['settlementType'].value === null) {
          swal.close();
          swal.fire(
            'Please Select Settlement Type',
            '',
            'warning'
          );
          return;
        }

        if (!this.settlementForm.valid) {
          swal.close();
          swal.fire(
            'Please Fill all required fields',
            '',
            'warning'
          );
          return;
        }
        if (!this.thispreviewimageUrl) {
          swal.close();
          swal.fire(
            'Please Upload Settlement Letter',
            '',
            'warning'
          );
          return;
        }
        for (let j = 0; j < this.documents.length; j++) {
          this.SettleDocs.$documents.push(this.documents[j]);
          if (this.data.claimDetails.locDetails) {
            this.data.claimDetails.locDetails.push(this.documents[j]);
            this.data.claimDetails.locDetails[this.data.claimDetails.locDetails.length - 1].authorizationAmount = this.data.claimDetails?.claimAmount?.tariffsAndDiscounts?.totalClaimedAmount - this.data.claimDetails?.claimAmount?.tariffsAndDiscounts?.totalDeductions;
          } else {
            this.data.claimDetails.locDetails = [];
            this.data.claimDetails.locDetails.push(this.documents[j]);
            this.data.claimDetails.locDetails[0].authorizationAmount = this.data.claimDetails?.claimAmount?.tariffsAndDiscounts?.totalClaimedAmount - this.data.claimDetails?.claimAmount?.tariffsAndDiscounts?.totalDeductions;
          }
        }
        this.SettleDocs.$documentType = 'Settlement Letter';
        this.listOfPaymentDetails = this.settlementForm.controls['settlementGroups'].value;
        this.data.claimDetails.claimStatus = this.settlementForm.controls['settlementType'].value;
        // this.PaymentDetails.$amount = this.settlementForm.controls['approvedAmount'].value;
        // this.PaymentDetails.$paidAmount = this.settlementForm.controls['paidAmount'].value;
        // this.PaymentDetails.$tdsAmount = this.settlementForm.controls['tdsAmount'].value;
        // this.PaymentDetails.$utrNumber = this.settlementForm.controls['utrNo'].value;
        // this.PaymentDetails.$dateOfPayment = this.settlementForm.controls['paymentDate'].value;
        // this.PaymentDetails.$commentBox = this.settlementForm.controls['commentBox'].value;
        // this.PaymentDetails.$settelementLetterDocument = this.SettleDocs;
        // listOfPaymentDetails

        if (this.data.claimDetails.listOfPaymentDetails) {
          for (let j = 0; j < this.listOfPaymentDetails.length; j++) {
            this.singlePayment = {};
            this.PaymentDetailsList = this.listOfPaymentDetails[j];
            // this.singlePayment.amount = this.settlementForm.controls['approvedAmount'].value;
            this.singlePayment.amount = this.PaymentDetailsList.paidAmount;
            this.singlePayment.tdsAmount = this.PaymentDetailsList.tdsAmount;
            this.singlePayment.utrNumber = this.PaymentDetailsList.utrNo;
            this.singlePayment.dateOfPayment = this.PaymentDetailsList.paymentDate;
            this.singlePayment.commentBox = this.PaymentDetailsList.commentBox;
            this.singlePayment.settelementLetterDocument = this.SettleDocs;
            this.data.claimDetails.listOfPaymentDetails.push(this.singlePayment);
          }
        } else {
          this.data.claimDetails.listOfPaymentDetails = [];
          for (let j = 0; j < this.listOfPaymentDetails.length; j++) {
            this.singlePayment = {};
            this.PaymentDetailsList = this.listOfPaymentDetails[j];
            // this.singlePayment.amount = this.settlementForm.controls['approvedAmount'].value;
            this.singlePayment.amount = this.PaymentDetailsList.paidAmount;
            this.singlePayment.tdsAmount = this.PaymentDetailsList.tdsAmount;
            this.singlePayment.utrNumber = this.PaymentDetailsList.utrNo;
            this.singlePayment.dateOfPayment = this.PaymentDetailsList.paymentDate;
            this.singlePayment.commentBox = this.PaymentDetailsList.commentBox;
            this.singlePayment.settelementLetterDocument = this.SettleDocs;
            this.data.claimDetails.listOfPaymentDetails.push(this.singlePayment);
          }
        }
        this.claimsService.unSettledClaim(this.data.claimDetails).subscribe(
          data => {
            swal.close();
            swal.fire('Claim Settled.', '', 'success');
            this.dialogRef.close('success');
          }
        );
        break;
      default:
        break;
    }
  }

  addDocument(event: any) {
    // Single Dot
    // JPEG, TIFF and PDF
    // Not more that 2 MB
    for (const file of event.target.files) {

      if (file.size > 15000000) {
        swal.close();
        swal.fire('', 'Cannot upload document with name ' + file.name + '. File size more than 15MB.', 'error');
        return;
      }

      if (file.name.indexOf('.') !== file.name.lastIndexOf('.')) {
        swal.close();
        swal.fire('', 'Cannot upload document with name ' + file.name + '. There can only be one period in file name.', 'error');
        return;
      }
      const validExtensions = ["jpg", "jpeg", "png", "tiff", "pdf", "xls", "xlsx", "xlsb", "doc", "docx", "csv", "zip"];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (validExtensions.indexOf(fileExtension) === -1) {
        swal.close();
        swal.fire('', 'Cannot upload document with name ' + file.name + '. Supported types are .pdf, .jpeg, .jpg, .png, .tiff, .xls, .xlsx, .xlsb, .doc, .docx, .csv, and .zip', 'error');
        return;
      }
    }


    if (event.target.files.length === 0) {
      return;
    }


    swal.fire({ title: 'Uploading Document/s' });
    swal.showLoading();

    for (const file of event.target.files) {
      for (let j = 0; j < this.data.claimDetails.claimDocuments.length; j++) {
        if (this.data.claimDetails.claimDocuments[j].documentType === "Query Letters") {
          const reader = new FileReader();
          const queryDoc = new DocumentDetails({});
          reader.readAsDataURL(file);
          reader.onload = function () {
            queryDoc.$file = reader.result;
            queryDoc.$canDelete = true;
            queryDoc.$extension = file.name.split('.').pop().toLowerCase();
            queryDoc.$name = file.name;
          };
          if (this.data.claimDetails.claimDocuments[j]?.documents?.length > 0) {
            this.data.claimDetails.claimDocuments[j].documents.push(queryDoc);
          } else {
            this.data.claimDetails.claimDocuments[j].documents = [];
            this.data.claimDetails.claimDocuments[j].documents.push(queryDoc);
          }
        }
      }
    }

    swal.close();
    swal.fire('Document/s uploaded successfully!', '', 'success');
  }

  addDocumentE(event: any) {
    // Single Dot
    // JPEG, TIFF and PDF
    // Not more that 2 MB
    // let thisImg = this;
    let thisImg = this;
    this.locDocFile = event.target.files[0];
    for (const file of event.target.files) {

      if (file.size > 15000000) {
        swal.close();
        swal.fire('', 'Cannot upload document with name ' + file.name + '. File size more than 15MB.', 'error');
        return;
      }

      if (file.name.indexOf('.') !== file.name.lastIndexOf('.')) {
        swal.close();
        swal.fire('', 'Cannot upload document with name ' + file.name + '. There can only be one period in file name.', 'error');
        return;
      }
      const validExtensions = ["jpg", "jpeg", "png", "tiff", "pdf", "xls", "xlsx", "xlsb", "doc", "docx", "csv", "zip"];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (validExtensions.indexOf(fileExtension) === -1) {
        swal.close();
        swal.fire('', 'Cannot upload document with name ' + file.name + '. Supported types are .pdf, .jpeg, .jpg, .png, .tiff, .xls, .xlsx, .xlsb, .doc, .docx, .csv, and .zip', 'error');
        return;
      }
    }


    if (event.target.files.length === 0) {
      return;
    }


    swal.fire({ title: 'Uploading Document/s' });
    swal.showLoading();

    for (const file of event.target.files) {
      const reader = new FileReader();
      const queryDoc = new DocumentDetails({});
      reader.readAsDataURL(file);
      reader.onload = function () {
        queryDoc.$file = reader.result;
        thisImg.thispreviewimageUrl = reader.result;
        queryDoc.$canDelete = true;
        queryDoc.$isAdded = false;
        queryDoc.$extension = file.name.split('.').pop().toLowerCase();
        queryDoc.$name = file.name;
      };
      this.locFile = queryDoc;
      // if(this.data.claimDetails.locDetails){
      //   // for (let j = 0; j < this.data.claimDetails.locDetails.length; j++) {
      //   //   if(this.data.claimDetails.locDetails[j]?.documents?.length > 0) {
      //   //     this.data.claimDetails.locDetails[j].documents.push(queryDoc);
      //   //   } else {
      //   //     this.data.claimDetails.locDetails[j].documents = [];
      //   //   this.data.claimDetails.locDetails[j].documents.push(queryDoc);
      //   //   }
      //   // }
      //   if(this.isLocAdded){
      //     let index = this.data.claimDetails.locDetails.length - 1;
      //     this.data.claimDetails.locDetails.splice(index, 1);
      //     index = this.data.claimDetails.locDetails.length;
      //     this.data.claimDetails.locDetails.push(queryDoc);
      //     index = this.data.claimDetails.locDetails.length;
      //   } else {
      //     this.data.claimDetails.locDetails.push(queryDoc);
      //     this.isLocAdded=true;
      //   }
      //   // this.data.claimDetails.locDetails.push(queryDoc);
      // } else {
      //   this.data.claimDetails.locDetails = [];
      //   this.data.claimDetails.locDetails.push(queryDoc);
      //   this.isLocAdded=true;
      // }
    }

    swal.close();
    // swal.fire('Document/s uploaded successfully!', '', 'success');
  }


  addSettledDocument(event: any) {
    let thisImg = this;
    for (const file of event.target.files) {

      if (file.size > 15000000) {
        swal.close();
        swal.fire('', 'Cannot upload document with name ' + file.name + '. File size more than 15MB.', 'error');
        return;
      }

      if (file.name.indexOf('.') !== file.name.lastIndexOf('.')) {
        swal.close();
        swal.fire('', 'Cannot upload document with name ' + file.name + '. There can only be one period in file name.', 'error');
        return;
      }
      const validExtensions = ["jpg", "jpeg", "png", "tiff", "pdf", "xls", "xlsx", "xlsb", "doc", "docx", "csv", "zip"];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (validExtensions.indexOf(fileExtension) === -1) {
        swal.close();
        swal.fire('', 'Cannot upload document with name ' + file.name + '. Supported types are .pdf, .jpeg, .jpg, .png, .tiff, .xls, .xlsx, .xlsb, .doc, .docx, .csv, and .zip', 'error');
        return;
      }
    }


    if (event.target.files.length === 0) {
      return;
    }


    swal.fire({ title: 'Uploading Document/s' });
    swal.showLoading();

    for (const file of event.target.files) {
      const reader = new FileReader();
      const queryDoc = new DocumentDetails({});
      reader.readAsDataURL(file);
      reader.onload = function () {
        queryDoc.$file = reader.result;
        thisImg.thispreviewimageUrl = reader.result;
        queryDoc.$canDelete = true;
        queryDoc.$isAdded = false;
        queryDoc.$extension = file.name.split('.').pop().toLowerCase();
        queryDoc.$name = file.name;
      };
      this.locFile = queryDoc;
      if (this.documents) {
        this.documents.push(queryDoc);
      } else {
        this.documents = [];
        this.documents.push(queryDoc);
      }
      // this.SettleDocs.$documents.push(queryDoc);
      // this.SettleDocs.$documentType = 'Settlement Letter';
    }
    swal.close();
  }

  addQueryDocument(event: any) {
    // Single Dot
    // JPEG, TIFF and PDF
    // Not more that 2 MB
    // let thisImg = this;
    let thisImg = this;
    this.locDocFile = event.target.files[0];
    for (const file of event.target.files) {

      if (file.size > 15000000) {
        swal.close();
        swal.fire('', 'Cannot upload document with name ' + file.name + '. File size more than 15MB.', 'error');
        return;
      }

      if (file.name.indexOf('.') !== file.name.lastIndexOf('.')) {
        swal.close();
        swal.fire('', 'Cannot upload document with name ' + file.name + '. There can only be one period in file name.', 'error');
        return;
      }
      const validExtensions = ["jpg", "jpeg", "png", "tiff", "pdf", "xls", "xlsx", "xlsb", "doc", "docx", "csv", "zip"];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (validExtensions.indexOf(fileExtension) === -1) {
        swal.close();
        swal.fire('', 'Cannot upload document with name ' + file.name + '. Supported types are .pdf, .jpeg, .jpg, .png, .tiff, .xls, .xlsx, .xlsb, .doc, .docx, .csv, and .zip', 'error');
        return;
      }
    }


    if (event.target.files.length === 0) {
      return;
    }


    swal.fire({ title: 'Uploading Document/s' });
    swal.showLoading();

    for (const file of event.target.files) {
      const reader = new FileReader();
      const queryDoc = new DocumentDetails({});
      reader.readAsDataURL(file);
      reader.onload = function () {
        queryDoc.$file = reader.result;
        thisImg.thispreviewimageUrl = reader.result;
        queryDoc.$canDelete = true;
        queryDoc.$isAdded = false;
        queryDoc.$extension = file.name.split('.').pop().toLowerCase();
        queryDoc.$name = file.name;
      };
      this.data.queryDocuments = [];
      this.data.queryDocuments.push(queryDoc);
    }

    swal.close();
    // swal.fire('Document/s uploaded successfully!', '', 'success');
  }

  async uploadDocumentModal() {
    if(this.data.statusType === 'DISCHARGE') {
      await this.claimsService.statusWiseDocs('FINAL_BILLS_SUBMITTED').subscribe(
        (data: any) => {
          data.body.forEach((element: any) => {
            if (element.mandatory) {
              this.data.claimDetails.claimDocuments.forEach((el: any) => {
                if (el.documentType === element.documentName) {
                  el.mandatory = true;
                }
              }
              )
            } else {
              this.data.claimDetails.claimDocuments.forEach((el: any) => {
                if (el.documentType === element.documentName) {
                  el.mandatory = false;
                }
              }
              )
            }
          });
        });
      const dialogRef = this.dialog.open(ClaimDocumentsListComponent, {
        width: '90vw',
        data: { claimDocs: this.data.claimDetails.claimDocuments, isUpload: true }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.totalDocument = 0;
          JSON.parse(result).forEach((element: any) => {
            if (element.documents) {
              this.totalDocument = this.totalDocument + element.documents.length;
            }
          });
          this.data.claimDetails.claimDocuments = JSON.parse(result);
        }
      });
    }
    else if (this.data.claimDetails.claimDocuments) {
      const dialogRef = this.dialog.open(ClaimDocumentsListComponent, {
        width: '90vw',
        data: { claimDocs: this.data.claimDetails.claimDocuments, isUpload: true }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.data.claimDetails.claimDocuments = JSON.parse(result);
          this.totalDocument = 0;
          this.data.claimDetails.claimDocuments.forEach((element: any) => {
            if (element.documents) {
              this.totalDocument = this.totalDocument + element.documents.length;
            }
          });
        }
      });
    } else {
      this.claimsService.getAllDocumentTypes().subscribe(
        (data: any) => {
          data.forEach((element: any) => {
            element.documents = [];
          });
          this.data.claimDetails.claimDocuments = data;
          const dialogRef = this.dialog.open(ClaimDocumentsListComponent, {
            width: '90vw',
            data: { claimDocs: this.data.claimDetails.claimDocuments, isUpload: true }
          });

          dialogRef.afterClosed().subscribe(result => {
            this.data.claimDetails.claimDocuments = JSON.parse(result);
            this.totalDocument = 0;
            this.data.claimDetails.claimDocuments.forEach((element: any) => {
              if (element.documents) {
                this.totalDocument = this.totalDocument + element.documents.length;
              }
            });
          });
        })
    }

  }

  downloadQueryDocument(fileUrl: any) {
    swal.showLoading();
    this.claimsService.fetchDocument(this.httpUrlEncodingCodec.decodeValue(fileUrl)).subscribe(
      (res: any) => {
        swal.close();
        if (res.body.docType === 'pdf') {
          this.queryLetter = res.body.docBaseSF;
        }

      },
      (err: any) => {
        swal.close();
        swal.fire('', err.error ? err.error : err.message, 'error');
      }
    );
  }
  masterAddItem() {
    const data = this.settlementForm.get('settlementGroups') as FormArray
    if (data.controls[data.controls.length - 1].invalid) {
      return;
    } else {
      data.push(this.settleMentFormGroup())
    }
    // this.lastLoopItem = data.controls.length - 1;
  }
  masterRemoveItem(i: number) {
    const data = this.settlementForm.get('settlementGroups') as FormArray
    if (data.length > 1) {
      data.removeAt(i)
    } else {
      data.reset()
    }
    // this.lastLoopItem = data.controls.length - 1;
  }
  getControls() {
    return (this.settlementForm.get('settlementGroups') as FormArray).controls;
  }
  showFile(fileUrl: any) {
    let convertedUrl = fileUrl.split(',');
    swal.showLoading();
    swal.close();
    this.dialog.open(DocumentViewerComponent, { width: '80vw', data: { imageSource: `${convertedUrl[1]}` } });
  }
  getSum() {
    this.data.claimDetails.invoiceDetails.totalNonClaimableAmount = Number(this.data.claimDetails.invoiceDetails.totalInvoiceAmount) - Number(this.data.claimDetails.invoiceDetails.totalApprovedAmount);
  }

  deleteDocument(i: number) {
    this.documents.splice(i, 1);
  }
}
